import { Doctor } from '../../store/interfaces/doctor'
import { Operator } from '../../store/interfaces/operator'
import { Permission } from '../permission.types'
import { DEFAULT_ROUTE_CANDIDATES } from '../permission-routes.config'
import { hasSupportedLegacyRole, isOperatorProfileRole, resolveLegacyRoleCodes } from './legacy-role.resolver'
import { permissionsForLegacyRoles } from './legacy-role-permissions.config'
import { LEGACY_DOCTOR_ROLE_PROFILE, LEGACY_ROLE, LegacyRoleCode } from './legacy-role.ids'

const HOME_VIEW_LEGACY_ROLES: readonly LegacyRoleCode[] = [
  LEGACY_ROLE.DOCTOR_ADMIN,
  LEGACY_ROLE.DOCTOR_SERVICE_DIRECTOR,
  LEGACY_ROLE.DOCTOR_DIRECTOR,
  LEGACY_ROLE.DOCTOR_PROFESSIONAL,
]

function canLegacyUserSeeHome(user: Doctor | Operator | null | undefined): boolean {
  const codes = resolveLegacyRoleCodes(user)
  if (!codes.length) return false
  if (isOperatorProfileRole(codes)) return false
  if (codes.includes(LEGACY_DOCTOR_ROLE_PROFILE.SERVICE_DIRECTOR_NO_SCHEDULE)) return false
  return codes.some((code) => HOME_VIEW_LEGACY_ROLES.includes(code))
}

export function canLegacyUser(user: Doctor | Operator | null | undefined, permission: Permission): boolean {
  if (!hasSupportedLegacyRole(user)) return false

  if (permission === Permission.HomeView) {
    return canLegacyUserSeeHome(user)
  }

  const perms = permissionsForLegacyRoles(resolveLegacyRoleCodes(user))
  if (permission === Permission.PatientsImport) {
    return perms.has(permission) && !!user?.canImportPatients
  }
  return perms.has(permission)
}

export function canLegacyUserAny(
  user: Doctor | Operator | null | undefined,
  permissions: readonly Permission[],
): boolean {
  if (!permissions.length) return true
  return permissions.some((p) => canLegacyUser(user, p))
}

export function getLegacyDefaultRoute(user: Doctor | Operator | null | undefined): string {
  for (const { path, permission } of DEFAULT_ROUTE_CANDIDATES) {
    if (canLegacyUser(user, permission)) return path
  }
  return '/sin-permisos'
}
